import api from '@/api'
import Report, { UnsupportedMediaTypeReport } from '@/api/communique/report'
import types from '@/types'

export default interface GeoCityStats {
  city: string
  region: string
  zip_code: string
  lat: number
  long: number
  imps: number
  clicks: number
}

interface queryParams {
  companyId: string
  mediaTypes?: string[]
  startDate?: string
  endDate?: string
  excludedInitiativeIDs?: string[]
  includedInitiativeIDs?: string[]
}

export class GeoCityStatsModel {
  public async fetchAll({
    companyId,
    mediaTypes,
    startDate,
    endDate,
    excludedInitiativeIDs,
    includedInitiativeIDs,
  }: queryParams): Promise<Report<GeoCityStats> | UnsupportedMediaTypeReport> {
    return api('report.dashboards.ihmCompany.geoCityStats')
      .params({
        companyId: companyId,
        media_types: mediaTypes,
        start_date: startDate,
        end_date: endDate,
        exclude_initiative_ids: excludedInitiativeIDs,
        include_initiative_ids: includedInitiativeIDs,
      })
      .cache(1000 * types.config.dashboardCacheSeconds())
      .jsonMust<Report<GeoCityStats>>()
  }
}
